module.exports = __webpack_public_path__ + "static/media/3section.48c7426e.png";